import { createAsyncThunk, createReducer } from "@reduxjs/toolkit";
import {
  confirmTask,
  updateSubtask,
  updateDescription,
  updateChatLen,
  updateFilesLen,
  updateAccountable,
  updateTaskLabel,
  updateTaskDeadlinePagination,
} from "./actions";

import api from "../../services/api";

function generateQueryString(params) {
  const query = new URLSearchParams();

  for (const key in params) {
    if (params[key] !== undefined && params[key] !== null) {
      query.append(key, params[key]);
    }
  }

  return `?${query.toString()}`;
}

export const fetchActivedTasks = createAsyncThunk(
  "activedTasks/fetchActivedTasks",
  async ({ page, queries = {} }, { rejectWithValue }) => {
    const { filters } = queries;

    try {
      const query = generateQueryString(filters);

      const route = "/activedtasks/pagination/" + page + "/" + query;

      const response = await api.get(route);

      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  },
);
const initialState = {
  pagination: [],
  pages: 1,
  status: "idle",
};

const activedTasksReducer = createReducer(initialState, {
  [fetchActivedTasks.pending]: (state, action) => {
    state.status = "loading";
  },
  [fetchActivedTasks.fulfilled]: (state, action) => {
    state.pagination = action.payload.pagination;
    state.pages = action.payload.totalPages;
    state.status = "succeeded";
  },

  [confirmTask]: (state, action) => {},

  [updateSubtask]: (state, action) => {
    const subtasks = action.payload.subtasks;
    const taskId = action.payload.taskId;

    state.pagination = state.pagination.map((task) =>
      task._id === taskId ? (task = { ...task, subtasks }) : task,
    );
  },

  [updateChatLen]: (state, action) => {
    const chatLen = action.payload.chatLen;
    const taskId = action.payload.taskId;

    state.pagination = state.pagination.map((task) =>
      task._id === taskId ? (task = { ...task, chatMessages: chatLen }) : task,
    );
  },

  [updateFilesLen]: (state, action) => {
    const filesLen = action.payload.fileLen;
    const taskId = action.payload.taskId;

    state.pagination = state.pagination.map((task) =>
      task._id === taskId ? (task = { ...task, files: filesLen }) : task,
    );
  },

  [updateDescription]: (state, action) => {
    const description = action.payload.description;
    const taskId = action.payload.taskId;

    state.pagination = state.pagination.map((task) =>
      task._id === taskId ? (task = { ...task, description }) : task,
    );
  },

  //task
  [updateTaskLabel]: (state, action) => {
    const label = action.payload.label;
    const taskId = action.payload.taskId;

    state.pagination = state.pagination.map((task) =>
      task._id === taskId ? (task = { ...task, label }) : task,
    );
  },

  [updateAccountable]: (state, action) => {
    const taskId = action.payload.taskId;
    const accountable = action.payload.accountable;

    state.pagination = state.pagination.map((task) =>
      task._id === taskId ? (task = { ...task, accountable }) : task,
    );
  },
  [updateTaskDeadlinePagination]: (state, action) => {
    console.log(action.payload);
  },
});

export default activedTasksReducer;
